import { RootState } from 'editor/src/store/index';

import { isEmbedded } from '../../watchers/useDisplayMode';

import isAddElementsAllowed from './isAddElementsAllowed';

/**
 * GAPI-61891: the image Soft edge control is opt-in per host (`enableImageFeather`).
 * In the embedded (buyer) editor it additionally follows the template's "Add layers"
 * switch, so a template that keeps its layers fixed does not get a new styling control.
 * Soft edges already in a design are always rendered; this only gates the control.
 */
const isImageFeatherAllowed = (state: RootState) =>
  !!state.hostSettings.enableImageFeather && (!isEmbedded || isAddElementsAllowed(state));

export default isImageFeatherAllowed;
